import React from "react";
import "./styles.css";
import Calculator from "./components/Calculator.js";

export default function App() {
  return (
    <div className="App">
      <Calculator />
    </div>
  );
}
